import { cn } from '@/lib/utils.js';

const OPTIONS = [
  { value: 'urgency', label: 'Urgency' },
  { value: 'counterparty', label: 'Counterparty' },
  { value: 'carrier', label: 'Carrier' },
  { value: 'deal', label: 'Deal' },
  { value: 'template', label: 'Template' },
  { value: 'kind', label: 'Kind' },
];

export default function GroupBySwitch({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-1">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={cn(
            'rounded-full px-3 py-1 text-xs font-medium transition-colors',
            value === opt.value
              ? 'bg-accent text-white'
              : 'bg-border/40 text-text-muted hover:bg-border/60 hover:text-text'
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
